import { HeaderTitlePortal } from './RetailerScopeWrapper'

interface HeaderPortalProps {
  /**
   * Displayed above the scope picker
   */
  headerComponent: JSX.Element
}

export const HeaderPortal = ({ headerComponent }: HeaderPortalProps) => (
  <HeaderTitlePortal>{headerComponent}</HeaderTitlePortal>
)
